import { injectable } from 'inversify';

import { IClient, IClientSummary } from '@modulate/shared/src/models/client';
import { IDataQueryRequest, IDataQueryResponse } from '@modulate/shared/src/models/data-query';
import api from '../axios-config';

export const CLIENT_SERVICE = Symbol.for('CLIENT_SERVICE');

export interface IEmail {
  email: string;
}

export interface IPhone {
  phone: string;
}

export interface IClientService {
  create(client: IClient): Promise<IClient>;
  getByUUID(id: string): Promise<IClient>;
  getSummary(clientId: string);
  updateEmail(email: IEmail, uuid: string);
}

@injectable()
export class ClientService implements IClientService {
  async getSummary(id: string): Promise<IDataQueryResponse<IClientSummary>> {
    const response = await api.get<IDataQueryResponse<IClientSummary>>(`/api/clients`);
    return response.data;
  }

  async create(client: IClient): Promise<IClient> {
    const response = await api.post<IClient>('/api/clients', client);
    return response.data;
  }

  async getByUUID(uuid: string): Promise<IClient> {
    const response = await api.get<IClient>(`/api/clients/${uuid}`);
    return response.data;
  }

  async updateEmail(email: IEmail, uuid: string): Promise<IClient> {
    const response = await api.patch<IClient>(`/api/clients/${uuid}/email`, email);
    return response.data;
  }

  async updatePhone(phone: IPhone, uuid: string): Promise<IClient> {
    const response = await api.patch<IClient>(`/api/clients/${uuid}/phone`, phone);
    return response.data;
  }
}
